import common from './modules/common'
import './registration.scss'

window.addEventListener('load', () => {
  common()
})